import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import Home from "@/pages/Home";
import Quote from "@/pages/Quote";
import Track from "@/pages/Track";
import { ServicesPage, ServiceAreaPage, ContactPage } from "@/pages/StaticPages";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Team from "@/pages/Team";
import Commercial from "@/pages/Commercial";
import Careers from "@/pages/Careers";
import BookAppointment from "@/pages/BookAppointment";
import ClientLogin from "@/pages/ClientLogin";
import ClientRegister from "@/pages/ClientRegister";
import ClientPortal from "@/pages/ClientPortal";
import AuthCallback from "@/pages/AuthCallback";
import { ClientAuthProvider } from "@/lib/clientAuth";
import { LOGO_URL } from "@/lib/api";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Chrome({ children, hideChrome }) {
  return (
    <>
      {!hideChrome && <Navbar />}
      <main className="min-h-screen">{children}</main>
      {!hideChrome && <Footer />}
    </>
  );
}

function AppShell() {
  const { pathname, hash } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  // Intercept the Emergent Google Auth callback (URL fragment) before any route/auth check
  if (hash && hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Chrome hideChrome={isAdmin}>
        {isAdmin && <MiniAdminBar />}
        {!isAdmin && <ChatWidget />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/service-area" element={<ServiceAreaPage />} />
          <Route path="/team" element={<Team />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/book" element={<BookAppointment />} />
          <Route path="/track" element={<Track />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/portal/login" element={<ClientLogin />} />
          <Route path="/portal/register" element={<ClientRegister />} />
          <Route path="/portal" element={<ClientPortal />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Chrome>
    </>
  );
}

function MiniAdminBar() {
  return (
    <div className="fixed top-0 inset-x-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-14 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2 group">
          <img src={LOGO_URL} alt="Laronta Pro" className="h-7 w-7 rounded-full object-cover ring-1 ring-slate-200" />
          <span className="font-heading font-black tracking-tight text-slate-900 text-sm">LARONTA PRO / ADMIN</span>
        </a>
        <a href="/" className="text-xs uppercase tracking-[0.2em] text-slate-500 hover:text-primary-brand">← Back to site</a>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App font-body bg-brand-bg text-slate-900">
      <BrowserRouter>
        <ClientAuthProvider>
          <AppShell />
        </ClientAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
